import { render, staticRenderFns } from "./excel.vue?vue&type=template&id=39f5c45e&scoped=true&"
import script from "./excel.component.ts?vue&type=script&lang=ts&"
export * from "./excel.component.ts?vue&type=script&lang=ts&"
import style0 from "./excel.vue?vue&type=style&index=0&id=39f5c45e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f5c45e",
  null
  
)

export default component.exports